import $ from 'jquery'

export default {

  enable () {
    $('.votre-etude-tabs').each((index, elem) => {

      let tabButtons = $(elem).find('.tab')
      let tabContentBlock = $(elem).find('.tab-contents')
      let tabContents = $(elem).find('.tab-content')

      let nextButton = $(elem).find('.next-button')
      let previousButton = $(elem).find('.previous-button')

      nextButton.click((e) => {
         let nextTabButton = $(elem).find('.tab.active').next('.tab')
         if(nextTabButton.length > 0) {
          nextTabButton.click()
         }
      })
      previousButton.click((e) => {
        let previousButton = $(elem).find('.tab.active').prev('.tab')
        if(previousButton.length > 0) {
          previousButton.click()
        }
     })
      tabButtons.click((e) => {
        let targetButton = $(e.target)
        let targetString = targetButton.attr('data-target')
        let target = $('.' + targetString)

        $(tabContents).removeClass('active')
        $(tabButtons).removeClass('active')

        target.addClass('active')
        targetButton.addClass('active')

      })

    })
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/votre-etude-tabs.js